import { SxProps } from "@mui/material";
import { ContextLabel, ParentTaskItemLabel } from "src/components";
import { TaskItemDetailDto, TaskItemDto } from "src/http";

interface Props {
  taskItem: TaskItemDto | TaskItemDetailDto;
  condensed?: boolean;
  sx?: SxProps;
}

const TaskItemContextLabel = (props: Props) => {
  if (props.taskItem.context) {
    return (
      <ContextLabel context={props.taskItem.context} showIcon hideTeamName condensed={props.condensed} sx={props.sx} />
    );
  }

  if (props.taskItem.parentTaskItem) {
    return (
      <ParentTaskItemLabel
        parentTaskItem={props.taskItem.parentTaskItem}
        showIcon
        hideTeamName
        condensed={props.condensed}
        sx={props.sx}
      />
    );
  }

  return null;
};

export { TaskItemContextLabel };
